import { render } from "./BarChart.vue?vue&type=template&id=6bae280d"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"
script.render = render

export default script